import { constants, typographyStyles } from "@newsela/angelou";

import {
  partialCtaDefaultLinearGradientBackground,
  partialCtaHoverLinearGradientBackground,
} from "../AiComponents.style";

const { colors } = constants;
const { fontFamily } = typographyStyles;

export const betaTagCss = (enableHoverEffect: boolean) => ({
  ...fontFamily.circular,
  display: "flex",
  alignItems: "center",
  margin: "0 2px",
  padding: "2px 4px",
  borderRadius: "0.15rem",
  fontWeight: 800,
  letterSpacing: "0.08rem",
  fontSize: "12px",
  height: "20px",
  zIndex: 1,
  width: "fit-content",
  lineHeight: "100%",
  ...partialCtaDefaultLinearGradientBackground,
  color: colors.brand.white[700],
  ":hover": {
    ...(!enableHoverEffect ? {} : partialCtaHoverLinearGradientBackground),
  },
});
